// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3TKB9","header":"MessagesList_header__ZFYZS","chat":"MessagesList_chat__u8mJx"};